export default __webpack_public_path__ + "static/media/longQueues.7104a5e1.jpg";